import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { css } from 'aphrodite/no-important';
import PrivateRoute from './PrivateRoute';
import Admin from '../containers/admin/Admin';
import AdminAlerts from '../containers/adminalerts/AdminAlerts';
import AdminHeader from '../containers/adminheader/AdminHeader';
import AdminSidebar from '../containers/adminsidebar/AdminSidebar';
import AdminStatus from '../containers/adminstatus/AdminStatus';
import AdminUsers from '../containers/adminusers/AdminUsers';
import Header from '../containers/header/Header';
import Home from '../containers/home/Home';
import Login from '../containers/login/Login';
import ForgotPassword from '../containers/forgotpassword/ForgotPassword';
import ResetPassword from '../containers/resetpassword/ResetPassword';
import Triggers from '../containers/triggers/Triggers';
import Notifications from '../containers/notifications/Notifications';
import NewUser from '../containers/newuser/NewUser';
import List from '../containers/list/List';
import NoSitesFound from '../containers/nositesfound/NoSitesFound';
import styles from './Router.styles';
import { getOrgs,loggedInAction } from '../reducers/actions';
import {INITD} from '../constants/app'
import GoogleAnalytics from './GoogleAnalytics'
import Chameleon from './Chameleon'

class Router extends Component {
  render() {
    let s = new URLSearchParams(document.location.search)
    if(s.get('accessToken')){
      this.props.loggedInAction(s.get('accessToken'))
    }

    // set orgId (opt param) to localStorage
    if(s.get('orgId')){
      localStorage.setItem("orgId", s.get('orgId'));
    }

    return (
      <BrowserRouter>
        <div className={css(styles.container)}>
          <Chameleon/>
          {/* wrap router into Google Analytics to detect every route change */}
          <GoogleAnalytics path="/">
            <Switch>
              <Route path="/login" component={Login} />
              <Route path="/forgot" component={ForgotPassword} />
              <Route path="/resetpassword" component={ResetPassword} />
              <Route path="/verify" component={NewUser} />
              <Route path="/admin" render={() => false} />
              <PrivateRoute
                path="/"
                component={Header}
                isAuthenticated={this.props.initd === INITD}
                isLoading={this.props.isLoading}/>
            </Switch>
            <Route path="/" component={() => this.props.isLoading && <div />} />

            {/* User routes */}

            <PrivateRoute
              exact
              path="/"
              component={List}
              isAuthenticated={this.props.isAuthenticated}
              isLoading={this.props.isLoading}
            />

            <PrivateRoute
              exact
              path="/map"
              component={Home}
              isAuthenticated={this.props.isAuthenticated}
              isLoading={this.props.isLoading}
            />

            <PrivateRoute
              exact
              path="/no-sites-found"
              component={NoSitesFound}
              isAuthenticated={this.props.isAuthenticated}
              isLoading={this.props.isLoading}
            />

            <PrivateRoute
              exact
              path="/triggers/:id"
              component={Triggers}
              isAuthenticated={this.props.isAuthenticated}
              isLoading={this.props.isLoading}
            />

            {/* Admin routes */}
            <Route
              path="/admin"
              render={() => (
                <div className={css(styles.adminSidebarContainer)}>
                  <Route path="/admin" component={AdminSidebar} />
                  <div className={css(styles.adminContainer)}>
                    <Route path="/admin" component={AdminHeader} />
                    <PrivateRoute
                      exact
                      path="/admin"
                      component={Admin}
                      isAuthenticated={this.props.isAuthenticated}
                      isLoading={this.props.isLoading}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/status"
                      component={AdminStatus}
                      isAuthenticated={this.props.isAuthenticated}
                      isLoading={this.props.isLoading}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/users"
                      component={AdminUsers}
                      isAuthenticated={this.props.isAuthenticated}
                      isLoading={this.props.isLoading}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/alerts"
                      component={AdminAlerts}
                      isAuthenticated={this.props.isAuthenticated}
                      isLoading={this.props.isLoading}
                    />
                  </div>
                </div>
              )}
            />
            <Notifications />
          </GoogleAnalytics>
        </div>
      </BrowserRouter>
    );
  }
}

function mapStateToProps({ isLoading, initd,  auth: { isAuthenticated }, organizations: { orgCount } }) {
  return { isAuthenticated, initd,  isLoading, orgCount };
}

function mapDispatchToProps(dispatch) {
  return {
    getOrgs() {
      dispatch(getOrgs());
    },
    loggedInAction(token){
      dispatch(loggedInAction(token))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Router);



// WEBPACK FOOTER //
// ./src/router/Router.js